<script lang="ts">
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  import { portal } from "svelte-portal/src/Portal.svelte";
  import { modals } from "$lib/stores/modal";

  export let backgroundColor: string;
  let style = backgroundColor ? `background-color: ${backgroundColor}` : "";
  export let isOpen = false;
  export let usePortal = false;
  export let lockOnOpen = false;
  export let className: null | string = null;

  const conditionalPortal = args => {
    return usePortal ? portal(args) : null;
  };

  const dispatch = createEventDispatcher<{
    close: any;
    open: any;
  }>();

  export const open = (event: any = {}) => {
    isOpen = true;
    if (lockOnOpen) {
      window.document.body.classList.add("locked");
    }
    dispatch("open", { isOpen, ...event });
  };

  export const close = (event: any = {}) => {
    isOpen = false;
    dispatch("close", { isOpen, ...event });
    modals.close();
    if (lockOnOpen) {
      window.document.body.classList.remove("locked");
    }
  };
</script>

<style lang="scss">
  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    width: 100vw;
    height: 100dvh;
    top: 0;
    left: 0;
    z-index: 1003;

    &--add-to-bag-bar {
      height: calc(100dvh - 72px);
    }
  }
</style>

<svelte:window
  on:keydown={e => {
    if (e.key === "Escape") {
      close();
    }
  }}
/>

{#if isOpen}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class={`modal${className !== null ? " " + className : ""}`}
    transition:fade
    {style}
    on:click|self={close}
    on:keydown
    use:conditionalPortal
  >
    <div role="dialog" aria-modal="true" aria-label="modal" tabindex="-1">
      <slot />
    </div>
  </div>
{/if}
